module.exports = __webpack_public_path__ + "media/images/flags/64/Estonia-d018e4c4852b20224ddbc421e355bedd.png";